<template>
  <div>
    <a class="bi ml-2 icon-grow bi-share tl-copy-page-permalink-icon"
         data-toggle="tooltip"
         data-html="true"
         data-placement="bottom"
         title="copy permalink to current page"
         :data-clipboard-text="windowUrl"></a>
  </div>
</template>

<script>
import ClipboardJS from "clipboard";

export default {
  name: "PagePermaLink",
  mounted () {
    this.initializeClipboardJS();
  },
  computed: {
    windowUrl() {
      return window.location.href;
    }
  },
  methods: {
    initializeClipboardJS() {
      const clipboard = new ClipboardJS('.tl-copy-page-permalink-icon');
      clipboard.on('success', function(e) {
        e.trigger.className = 'bi ml-2 bi-check-circle tl-copy-page-permalink-icon tl-copy-page-permalink-icon-checked';
        e.trigger.dataset.originalTitle="the current page url has been copied to clipboard";
      });
    }
  }
}
</script>
<style>


.tl-copy-page-permalink-icon {
  cursor:pointer;
  font-size: 1.5em;
}

.tl-copy-page-permalink-icon-checked {
  color: forestgreen;
}

.tl-copy-page-permalink-icon-checked:hover {
  color: forestgreen;
}

</style>

